module.exports = __webpack_public_path__ + "img/send-icon.ce582198.svg";